import React from 'react';
import withDebounce from '../../../../../incase-domain/components/utils/WithDebounce';
import InputWithCharacterCounter, {CharacterCounterProps} from '../InputWithCharacterCounter';
import {COMPARISON_TYPE} from '../../../../../hooks/useCharacterCounter';

const DebounceWrapped = withDebounce<CharacterCounterProps, string>(InputWithCharacterCounter);

function DebouncedTextInput(props: CharacterCounterProps): JSX.Element {
    return <DebounceWrapped {...props} comparisonType={COMPARISON_TYPE.GREATER_THAN} />;
}

export default DebouncedTextInput;
